<template lang="pug">
  div
    app-modal-erro-versao(v-if="showModalErroVersao", @closeModal="()=> showModalErroVersao = false")
    h1.titulo Enviar Cadastro
    el-row(type="flex" class="row-bg" justify="space-between")
      el-col.col-texto(
        :md="12",
        :lg="12"
      )
        div
          h3.titulo Instruções para envio do cadastro
          p
            b 1.&nbsp
            | Após concluído o cadastro no {{SISTEMA}} Módulo Banco de Dados,
            | exporte este cadastro para seu computador. Este arquivo exportado possui a extensão &nbsp
            span.verde .sicarf
            |.
          p
            b 2.&nbsp
            | Para importação, clique no ícone de nuvem e selecione o arquivo.
          p
            b 3.&nbsp
            | Após o envio, será gerado um comprovante com um número de protocolo.
            | Guarde este documento com segurança em seu computador ou realize a impressão.
          p
            b 4.&nbsp
            | O protocolo poderá ser solicitado posteriormente para acompanhamento do processo junto {{isRondonia ? 'à' :'ao'}} {{ORGAO}}
            | não sendo possível emitir segunda via do mesmo.
          p
            b 5.&nbsp
            | Pronto! Versões de cadastros suportadas: {{ versao }}

      el-col.col-upload(
        :md="12",
        :lg="12"
      )
        app-upload-tus-cadastro(
          @uploadSuccess="success",
          @uploadFail="fail"
          @selectedFile="setShowDownloadComprovante"
        )
    .container-video
      iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="50%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.COMO_ENVIAR" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")

    el-row(
      type="flex",
      class="row-bg",
      justify="space-between",
      v-if="showDownloadComprovante",
    )
      el-col(
        :md="24",
        :lg="24",
      )
        div.download-comprovante
          el-button(
            v-if="this.protocolo !== 'PROCESSAMENTO'"
            @click="gerarComprovante()",
            type="primary",
            icon="fas fa-cloud-download-alt"
          ) &nbsp Realizar Download do Comprovante
          el-button(
            v-else
            @click="estouCiente()",
            type="primary",
            icon="fas fa-cloud-download-alt"
          ) &nbsp Estou ciente

</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppUploadTusCadastro from './AppUploadTusCadastro'
import AppModalErroVersao from '@/components/AppModalErroVersao.vue'
import { mapActions, mapState } from 'vuex'

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    AppUploadTusCadastro,
    AppModalErroVersao
  },

  name: 'UploadCadastro',

  data () {
    return {
      file: {},
      idCadastroUpload: null,
      protocolo: null,
      showDownloadComprovante: false,
      versao: '',
      showModalErroVersao: false
    }
  },

  created () {
    this.getVersaoUploadAction().then(data => {
      this.versao = data
    })
  },

  methods: {
    ...mapActions({
      getVersaoUploadAction: 'upload/getVersaoUpload',
      gerarComprovanteAction: 'upload/gerarComprovante',
      resetLoader: 'loader/resetLoader'
    }),

    estouCiente () {
      this.showDownloadComprovante = false
      this.protocolo = null
    },

    setShowDownloadComprovante (file) {
      this.file = file
    },

    async success (response) {
      this.resetLoader()
      this.protocolo = response
      const msgConfirm = this.protocolo === 'PROCESSAMENTO' ? `Atenção: Seu processo passará pela análise automatizada de jurisdição/monitoramento ambiental. Dentro de alguns minutos, você receberá um e-mail com o retorno das análises.`
        : `Após o envio, será gerado um Comprovante com um número de protocolo. Guarde este documento com segurança em seu
        computador ou realize a impressão.
        <p>O protocolo poderá ser solicitado posteriormente
        para acompanhamento do processo junto ao ${this.ORGAO} não sendo possível emitir segunda via do mesmo.<p>`

      await this.$alert(msgConfirm, 'Gerar comprovante', {
        confirmButtonText: 'Continuar',
        dangerouslyUseHTMLString: true,
        customClass: 'confirm-finalizar',
        showClose: false
      })
      this.showDownloadComprovante = this.file !== null

      if (this.protocolo === 'PROCESSAMENTO') {
        this.file = {}
        this.idCadastroUpload = null
        return
      }

      this.gerarComprovante()
      this.showNotificacao(
        'success',
        'Concluído',
        'Importação do cadastro foi realizado com sucesso.'
      )
    },

    fail (error) {
      this.showDownloadComprovante = false
      if (error.response.data.messageTitle === 'Versão desatualizada!') {
        this.showModalErroVersao = true
      }
    },

    gerarComprovante () {
      try {
        this.gerarComprovanteAction(this.protocolo)
      } catch (error) {
        this.showNotificacao(
          'error',
          'Erro',
          'Ocorreu um problema ao gerar o comprovante. Acesse a central do interessado para gerar uma segunda via.'
        )
      }
    }
  },

  computed: {
    ...mapState({
      SISTEMA: state => state.userInterface.dadosEstado.SISTEMA,
      ORGAO: state => state.userInterface.dadosEstado.ORGAO,
      VIDEOS_TUTORIAIS: state => state.userInterface.dadosEstado.PUBLICO.VIDEOS_TUTORIAIS
    }),
    isRondonia () {
      return process.env.ESTADO === 'ro'
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/styles/element-variables.scss';

.confirm-finalizar {
  width: 30%;
  .el-message-box__status + .el-message-box__message {
    padding-left: 45px;
  }
  .el-message-box__status.el-icon-warning.tooltip-icon {
    font-size: 30px !important;
  }
}

.container-video {
  width: 100%;
  display: flex;
  justify-content: center;
}

.col-upload {
  padding: 0 0 0 20px;
}

.col-texto {
  padding: 0 20px 0 0;
}

.download-comprovante {
  align-items: center;
  text-align: center;
  margin: 10% 0;
}

b {
  color: $--color-primary;
}

.verde {
  color: $--color-primary;
}

.body {
  width: 68vw;
  margin: auto;
}

.height {
  height: 50%;
}

.upload {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.card {
  font-size: 14px;
  width: 25vw;
  min-height: 370px;
  min-width: 400px;
  margin: auto;
  margin-bottom: 20px;
}

.titulo {
  color: $--color-primary;
}

h3 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: $--color-primary;
}

p {
  line-height: 1.5;
  font-size: 16px;
}

iframe {
  border-radius: 10px;
  margin-top: 50px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUploadCadastro.vue